/** @format */
import Cookies from "js-cookie";

export async function getDocByStatusADM(Status, ModelId, ClientId, token) {
  const api_url = Cookies.get("ApiUrl");
  const apiUrl = `${api_url}/admin/document/list/bystatus`;
  try {
    const requestBody = {
      Status,
      ModelId,
    };

    if (ClientId) {
      requestBody.ClientId = ClientId;
    }

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}
